import { combineReducers } from 'redux';
import {
  LOGOUT_USER,
} from 'actions';

import {
  scheduleSettingsReducer,
  scheduleReducer,
  durationPreviewReducer,
  scheduleCategoriesReducer,
  categoryAthletesReducer,
} from './Schedule';

import {
  ageCategoriesListReducer,
} from './AgeCategories'

import {
  loginLogListReducer,
} from './LoginLog'

import {
  applicationListReducer,
  applicationPostReducer,
} from './Application'

import {
  associationListReducer,
  associationPostReducer,
  associationPatchReducer,
} from './Association'

import {
  clubListReducer,
  clubPatchReducer,
  clubPostReducer
} from './Clubs'

import {
  competitionListReducer,
  competitionPatchReducer,
  competitionPostReducer,
} from './Competition'

import {
  competitionCategoryListReducer,
  competitionCategoryPatchReducer,
} from './CompetitionCategory'

import {
  competitionSecretaryListReducer,
  competitionSecretaryPostReducer,
  competitionSecretaryDeleteReducer,
} from './CompetitionSecretary'

import {
  competitionResultListReducer,
  competitionResultPatchReducer,
  drawChangesReducer,
} from './CompetitionResult'

import {
  categoryOverviewReducer,
} from './CategoryOverview'

import {
  disciplineListReducer,
} from './Disciplines'

import {
  shootingResultListReducer,
} from './ShootingResults'

import {
  attendanceListReducer,
} from './Attendance'

import {
  competitionSportsmanNumberListReducer,
} from './CompetitionSportsmanNumber'

import {
  msacFinalResultListReducer,
} from './MsacFinalResults'

import {
  feeListReducer,
  postReducer as feePostReducer,
} from './Fees'

import {
  locationsReducer,
  locationPostReducer,
} from './Locations'

import {
  qualificationListReducer,
} from './Qualification'

import { listReducer as fightProtocolReducer } from './FightProtocol'

import {
  listReducer as operationsListReducer,
  workspaceReducer as tatamiWorkspaceReducer,
} from './Operations'

import {
  listReducer as participantListReducer,
  patchReducer as participantPatchReducer,
  postReducer as participantPostReducer,
  deleteReducer as participantDeleteReducer,
  competitionParticipantsListReducer,
} from './Participant'

import {
  profileReducer,
  profileDeleteReducer,
  profileEditReducer,
  profileListReducer,
  profilePatchReducer,
  profilePostReducer,
} from './Profile'

import {
  rankListReducer,
} from './Ranks'

import {
  deleteReducer as refereeDeleteReducer,
  listReducer as refereeListReducer,
  patchReducer as refereePatchReducer,
  postReducer as refereePostReducer,
} from './Referee'

import {
  ruleListReducer,
  rulePostReducer,
} from './Rules'

import {
  ruleCategoryDeleteReducer,
  ruleCategoryListReducer,
  ruleCategoryPatchReducer,
  ruleCategoryPostReducer,
} from './RuleCategories'

import {
  deleteReducer as secretaryDeleteReducer,
  listReducer as secretaryListReducer,
  patchReducer as secretaryPatchReducer,
  postReducer as secretaryPostReducer,
} from './Secretary'

import {
  sportsmenListReducer,
  sportsmanDeleteReducer,
  sportsmanPostReducer,
  sportsmanPatchReducer,
} from './Sportsmen'

import {
  default as snackBarReducer,
} from './SnackBar'

import {
  listReducer as teamListReducer,
  patchReducer as teamPatchReducer,
  postReducer as teamPostReducer,
  deleteReducer as teamDeleteReducer,
} from './Team'

import {
  deleteReducer as trainerDeleteReducer,
  listReducer as trainerListReducer,
  patchReducer as trainerPatchReducer,
  postReducer as trainerPostReducer,
} from './Trainer'

import {
  default as validationReducer,
} from './Validation'

import {
  authReducer,
  registerReducer,
} from './User';

import {
  userManagementListReducer,
  userManagementPostReducer,
  userManagementPatchReducer,
} from './Users';

const appReducer = combineReducers({
  ageCategories: ageCategoriesListReducer,
  loginLogs: loginLogListReducer,

  applications: applicationListReducer,
  applicationsPost: applicationPostReducer,

  associations: associationListReducer,
  associationPost: associationPostReducer,
  associationPatch: associationPatchReducer,

  clubs: clubListReducer,
  clubPost: clubPostReducer,
  clubPatch: clubPatchReducer,

  competitions: competitionListReducer,
  competitionPatch: competitionPatchReducer,
  competitionPost: competitionPostReducer,

  competitionCategories: competitionCategoryListReducer,
  competitionCategoryPatch: competitionCategoryPatchReducer,

  competitionSecretaries: competitionSecretaryListReducer,
  competitionSecretaryPost: competitionSecretaryPostReducer,
  competitionSecretaryDelete: competitionSecretaryDeleteReducer,

  fees: feeListReducer,
  feePost: feePostReducer,

  locations: locationsReducer,
  locationPost: locationPostReducer,
  qualifications: qualificationListReducer,
  fightProtocols: fightProtocolReducer,
  operations: operationsListReducer,
  tatamiWorkspace: tatamiWorkspaceReducer,
  participants: participantListReducer,
  competitionParticipants: competitionParticipantsListReducer,
  participantPost: participantPostReducer,
  participantPatch: participantPatchReducer,
  participantDelete: participantDeleteReducer,
  profile: profileReducer,
  profileDelete: profileDeleteReducer,
  profileEdit: profileEditReducer,
  profiles: profileListReducer,
  profilePatch: profilePatchReducer,
  profilePost: profilePostReducer,
  ranks: rankListReducer,

  disciplines: disciplineListReducer,

  shootingResults: shootingResultListReducer,
  attendance: attendanceListReducer,
  competitionSportsmanNumbers: competitionSportsmanNumberListReducer,
  msacFinalResults: msacFinalResultListReducer,

  refereeDelete: refereeDeleteReducer,
  referees: refereeListReducer,
  refereePatch: refereePatchReducer,
  refereePost: refereePostReducer,

  rules: ruleListReducer,
  rulePost: rulePostReducer,
  ruleCategories: ruleCategoryListReducer,
  ruleCategoryPost: ruleCategoryPostReducer,
  ruleCategoryPatch: ruleCategoryPatchReducer,
  ruleCategoryDelete: ruleCategoryDeleteReducer,
  results: competitionResultListReducer,
  resultsPatch: competitionResultPatchReducer,
  categoryOverview: categoryOverviewReducer,
  drawChanges: drawChangesReducer,

  secretaryDelete: secretaryDeleteReducer,
  secretaries: secretaryListReducer,
  secretaryPatch: secretaryPatchReducer,
  secretaryPost: secretaryPostReducer,

  snackBar: snackBarReducer,
  sportsmen: sportsmenListReducer,
  sportsmenDelete: sportsmanDeleteReducer,
  sportsmanPost: sportsmanPostReducer,
  sportsmanPatch: sportsmanPatchReducer,
  teams: teamListReducer,
  teamPost: teamPostReducer,
  teamPatch: teamPatchReducer,
  teamDelete: teamDeleteReducer,
  trainerDelete: trainerDeleteReducer,
  trainers: trainerListReducer,
  trainerPatch: trainerPatchReducer,
  trainerPost: trainerPostReducer,
  userSession: authReducer,
  userRegistration: registerReducer,
  userManagement: userManagementListReducer,
  userManagementPost: userManagementPostReducer,
  userManagementPatch: userManagementPatchReducer,
  validation: validationReducer,
  scheduleSettings: scheduleSettingsReducer,
  schedule: scheduleReducer,
  durationPreview: durationPreviewReducer,
  scheduleCategories: scheduleCategoriesReducer,
  categoryAthletes: categoryAthletesReducer,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_USER) {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer;
